import * as React from "react"
import { useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"

import { SitesMultiSelect } from "@components"
import { BACKEND_APIS } from "@constants"
import { selectedMarkets, selectedSites, sitesOptions } from "../@signals"

export default function SkuCandidatesSitesFilter() {
    useEffect(() => {
        const params = { all: 1 }
        if (selectedMarkets.value?.length > 0) {
            params.markets = selectedMarkets.value.join(',')
        }
        getSubmit(`${BACKEND_APIS.SKU_CANDIDATES}/sites`, params)
            .then(res => { if (res) sitesOptions.value = res })
            .catch(err => console.error('Error fetching sites:', err))
    }, [selectedMarkets.value])

    return <SitesMultiSelect
        options={sitesOptions.value}
        value={selectedSites.value}
        onChange={(newValue) => selectedSites.value = newValue}
    />
}
